// dispatchHelper passes `payload.data || payload` to callbacks. An HTTP 200 body
// `{success:false, code, message, data}` would then drop the failure fields. Flatten
// the inner data onto the envelope so the callback still sees `success: false`.
// Drop a nested `data` key so a later unwrap cannot hide `success: false` again.
const preserveFailedAppFixerEnvelope = (response) => {
  const body = response?.data;
  if (!body || typeof body !== 'object' || Array.isArray(body) || body.success !== false) {
    return response;
  }
  if (body.data === undefined || body.data === null) {
    return response;
  }
  const details = typeof body.data === 'object' && !Array.isArray(body.data) ? body.data : { details: body.data };
  const { data: innerData, ...rest } = details;
  return {
    ...response,
    data: {
      ...rest,
      ...(innerData !== undefined && rest.details === undefined ? { details: innerData } : {}),
      success: false,
      ...(body.code != null ? { code: body.code } : {}),
      ...(body.message != null ? { message: body.message } : {})
    }
  };
};

export default preserveFailedAppFixerEnvelope;
